import { useEffect, useState } from 'react';

/** Игнорируем мелкие расхождения visualViewport vs innerHeight (сворачивание
 *  URL-бара, тулбары браузера) — клавиатура всегда отъедает заметно больше. */
const KEYBOARD_THRESHOLD = 90;

/**
 * Высота, которую софт-клавиатура «отъедает» снизу (px), через `visualViewport`.
 * 0 — клавиатура закрыта или API недоступно (десктоп/старые браузеры).
 *
 * На iOS Safari layout-viewport при открытии клавиатуры НЕ сжимается, поэтому
 * обычный `position:fixed; bottom:0` уезжает под клавиатуру. Этот inset нужно
 * приложить как `translateY(-inset)` к нижней панели ввода, чтобы она всегда
 * висела над клавиатурой.
 */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      const overlap = window.innerHeight - vv.height - vv.offsetTop;
      setInset(overlap > KEYBOARD_THRESHOLD ? Math.round(overlap) : 0);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
}
